import React from "react";
import { BrowserRouter } from "react-router-dom";
import {
  InterestsProvider,
  LoadingProvider,
  NotificationProvider,
  UserProvider,
  PresenceProvider,
} from "@/contexts";
import { Loading } from "@/components";
import _Routes from "./routes/_Routes";
import { AnalyticsInterceptor } from "./interceptors/AnalyticsInterceptor";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";

function App() {
  const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY_PROD || "");

  return (
    <LoadingProvider>
      <PresenceProvider>
        <UserProvider>
          <InterestsProvider>
            <NotificationProvider>
              <BrowserRouter>
                <AnalyticsInterceptor />
                <Elements stripe={stripePromise}>
                  <_Routes />
                </Elements>
                <Loading />
              </BrowserRouter>
            </NotificationProvider>
          </InterestsProvider>
        </UserProvider>
      </PresenceProvider>
    </LoadingProvider>
  );
}

export default App;
